export default function OverviewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.8335 14.1666V10.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 14.1666V5.83331"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.1665 14.1667V9.16669"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.0835 9.99998C2.0835 6.26803 2.0835 4.40205 3.24286 3.24268C4.40224 2.08331 6.26821 2.08331 10.0002 2.08331C13.7321 2.08331 15.5981 2.08331 16.7575 3.24268C17.9168 4.40205 17.9168 6.26803 17.9168 9.99998C17.9168 13.7319 17.9168 15.5979 16.7575 16.7573C15.5981 17.9166 13.7321 17.9166 10.0002 17.9166C6.26821 17.9166 4.40224 17.9166 3.24286 16.7573C2.0835 15.5979 2.0835 13.7319 2.0835 9.99998Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
